// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Montserrat', 'Montserrat Fallback'"},"className":"__className_34dbb4"};